export const mutations = {
  setSystemActions(state, payload) {
    state.systemactions = payload
  }
};

export default {};
